import Vue from 'vue';

export default {
    /**
     * Set shows
     *
     * @param {object} state    Vuex state.
     * @param {Array}  shows    Array of shows objects.
     */
    setShows(state, shows) {
        state.shows = shows;
    },

    /**
     * Update show
     *
     * @param {object}  state           Vuex state.
     * @param {object}  payload         Payload object.
     * @param {number}  payload.id      Show ID.
     * @param {object}  payload.data    Show Object.
     */
    updateShow(state, { hash, data: updatedShowData }) {
        state.shows[hash] = {
            ...state.shows[hash],
            ...updatedShowData,
        };
    },

    /**
     * Add show
     *
     * @param {object}  state           Vuex state.
     * @param {object}  showData            Show object.
     */
    addShow(state, showData) {
        state.shows = {
            ...state.shows,
            ...showData,
        };
    },

    /**
     * Delete show
     *
     * @param {object}  state           Vuex state.
     * @param {string}  hash    Show hash.
     */
    deleteShow(state, hash) {
        Vue.delete(state.shows, [hash]);
    },

    /**
     * Sets show categories.
     *
     * @param {object}  state       Vuex state.
     * @param {object}  categories  Show categories.
     */
    setShowCategories(state, categories) {
        state.showCategories = categories;
    },

    /**
     * Set directories
     *
     * @param {object} state    Vuex state.
     * @param {object}  data    Directories.
     */
    setDirectories(state, data) {
        state.directories = data;
    },
};
